import { all } from 'redux-saga/effects';
import {
  watchLogin,
  watchRefreshToken,
  watchFetchUserProfile,
  watchForgotPassword,
  watchResetPassword,
  watchUpdatePassword,
  watchVerifyOtp,
  watchResendOtp,
  watchSendOtp,
  watchLogout,
  watchFetchRestaurants,
} from './authSaga';
import { watchMenuSaga } from './menuSaga';

export default function* rootSaga() {
  yield all([
    watchLogin(),
    watchRefreshToken(),
    watchFetchUserProfile(),
    watchForgotPassword(),
    watchResetPassword(),
    watchUpdatePassword(),
    watchVerifyOtp(),
    watchResendOtp(),
    watchSendOtp(),
    watchLogout(),
    watchFetchRestaurants(),
    watchMenuSaga(),
  ]);
}
